import { render, staticRenderFns } from "./EmployeeLeaveAddForm.vue?vue&type=template&id=6c1c61e0&scoped=true&"
import script from "./EmployeeLeaveAddForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeLeaveAddForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeLeaveAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmployeeLeaveAddForm.vue?vue&type=style&index=1&id=6c1c61e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c61e0",
  null
  
)

export default component.exports